import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { TTProtection } from "../../TTProtection";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";

export const TTProtectionNameForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<TTProtection>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput name="Name" control={control} disabledFields={disabledFields} required />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput name="Version" control={control} disabled />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput name="ImplementationDate" control={control} label="Date Created" disabled />
      </Grid>
    </BorderedFormGrid>
  );
};
